










































































































import { Component, Prop } from 'vue-property-decorator';
import colors from 'vuetify/lib/util/colors';
import IconUser from '@/assets/icons/user.svg';
import CSelectButtons from '@/components/Helper/Form/CSelectButtons.vue';
import { PropType } from 'vue';
import { StaffEntity } from '@/entities/staff.entity';
import BtnSendThankMixin from '@/components/ViewComponent/Issue/IssueDetail/BtnResolveIssue/btn-send-thank.mixin';

@Component<BtnSendThankMessage>({
  components: { CSelectButtons },
})
export default class BtnSendThankMessage extends BtnSendThankMixin {
  @Prop({ type: Object as PropType<StaffEntity>, required: true })
  supporter: StaffEntity;

  colors = colors;

  icons = {
    IconUser,
  };

  created() {
    this.resolveData.supporterId = this.supporter.id;
  }

  get btnStyle() {
    let border = `thin solid ${colors.orange.lighten2}!important`;
    if (this.isReceivedThanks) {
      border = `thin solid ${colors.blue.base}!important`;
    } else if (this.issue.isResolved) {
      border = `thin solid ${colors.grey.lighten1}!important`;
    }
    return {
      border,
      ...(this.isReceivedThanks
        ? {
            backgroundColor: `${colors.blue.lighten2} !important`,
            color: 'white!important',
          }
        : {}),
    };
  }

  get btnText() {
    if (this.isReceivedThanks) {
      return this.$t('issue.selected');
    }
    return this.$t('thanks.addThanks');
  }

  get isReceivedThanks() {
    const receivedThankStaffIds = this.issue.receivedThankStaffIds || [];
    return receivedThankStaffIds.includes(this.supporter.id);
  }
}
